import React from "react";
import "./Home-inquiry.css";

import Enquiry_form_modal from "../../common-section/Modals/enquiry-form-modal/Enquiry_form_modal";

const Home_inquiry = () => {
  const [modalShow, setModalShow] = React.useState(false);

  return (
    <>
      <section className="Home_inquiry_sec">
        

        <div className="container inuuupoos">
        {/* <div className="overlay-bg"></div> */}
        <img className="overlay-bg" src={process.env.PUBLIC_URL + '/assets/images/homepage/inquiry/banner.png'} />
          
          <div className="overlaycont">
          <div className="row">
            <div className="col-md-12 my-auto">
              <h1 className="openyuor">
                Got  Questions?
              </h1>
              <p className="letsbring">Lets Bring Your Vision to Life</p>
            </div>
            <div className="col-md-6 my-auto ">
              <button
                className="enquiry-btn btn"
                onClick={() => setModalShow(true)}
              >
                ENQUIRE TODAY
              </button>
            </div>
          </div>
          </div>
        </div>

        <Enquiry_form_modal
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </section>
    </>
  );
};

export default Home_inquiry;
